module.exports = __webpack_public_path__ + "img/news.a596c264.png";